import { useState } from "react";
import { LOGO_url } from "../../utils/constants";
import './Login.css';
import { useNavigate } from "react-router-dom";
import {useAuth} from '../../context/AuthContext';
import { api } from "../../services/api";
import { toast } from "react-toastify";

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [errors,setErrors] = useState({});
    // const [serverError, setServerError] = useState('');
    const navigate = useNavigate(); 
    const {login,setUser,initializeAuth} =useAuth();

    const validateForm = () =>{
        const validationErrors = {};
        if (!email) validationErrors.email = "Email is required.";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
        validationErrors.email = "Invalid email format.";

        if (!password) validationErrors.password = "Password is required.";
        return validationErrors;
    };
  
    const handleLogin = async(e) => {
        e.preventDefault();

        const validationErrors = validateForm();
            if (Object.keys(validationErrors).length > 0) {
                setErrors(validationErrors);
                return;
            }

        setErrors({});
        // setServerError("");

      try {
        const authInitialized = await initializeAuth(email, password);
        if (!authInitialized) {
            // toast.error("Authentication initialization failed.");
            return;
        }
        const response = await api.auth.login({email,password});
        const { data } = response;
        setUser(data.user);

        if(data.status ==='success'){
            login(localStorage.getItem('token'), data.user);

            if (data.requires_password_change) {
                navigate("/change-password");
            } else {
                navigate("/home/dashboard");
            }
        }else{
            setTimeout(()=>{
                toast.error(data?.message || 'Failed to change password');
            },2000)
        }
        } catch (error) {
        // setServerError(error.response?.data?.error || "Login failed. Please try again.");
      }
    };
    return (
        <div className="main">
            <div className="login-container">
                <div className="logo-container">
                    <img className="logo" src={LOGO_url} alt="Logo" />
                </div>
                <div className="login-box">
                    <h2>Hello Again!</h2>
                    <p>Welcome Back</p>
                    <form className="login-form" onSubmit={handleLogin}>
                        <div className="form-group">
                            <div className="input-icon-container">
                                <input 
                                    type="email" 
                                    id="email" 
                                    placeholder="Email Address" 
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <span className="input-icon">
                                    <img src="/assets/icons/email-icon.svg" alt="Email Icon" />
                                </span>
                            </div> 
                            {errors.email && <p className="error-text">{errors.email}</p>}
                        </div>
                        <div className="form-group">
                            <div className="input-icon-container">
                                <input 
                                    type={
                                        showPassword ? "text" : "password"
                                    }
                                    id="password" 
                                    placeholder="Password" 
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <span className="input-icon">
                                    <img src="/assets/icons/password-icon.svg" alt="Password Icon" />
                                </span>
                            </div>
                            {errors.password && <p className="error-text">{errors.password}</p>}
                        </div>
                        <div className="row mb-1">
                            <div className="col d-flex">
                                <div className="form-check">
                                    <input 
                                        className="form-check-input"
                                        type="checkbox" 
                                        id="showPWD"
                                        value={showPassword}
                                        onChange={() =>
                                            setShowPassword((prev) => !prev)
                                        }
                                     />
                                    <label className="form-check-label" htmlFor="showPWD"> Show Password </label>
                                </div>
                            </div>

                            {/* <div className="col forgotPwd">
                            <Link to="/forgot-password">Forgot password?</Link>
                            </div> */}
                        </div>
                        {/* {serverError && <p className="error-text">{serverError}</p>}  */}
                        <button type="submit" className="btn btn-primary btn-lg btn-xl generalBtn">Login</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
